import {Group, GroupProps} from "@mantine/core";
import CreatedSmallBadge from "./CreatedSmallBadge";
import FolderSmallBadge from "./FolderSmallBadge";

type SmallBadgeContainerPropsBase = {};

type SmallBadgeContainerProps = GroupProps & SmallBadgeContainerPropsBase;

/**
 * Container for SmallBadgeContainer.
 * @param props
 * @constructor
 */
function SmallBadgeContainer(props: SmallBadgeContainerProps) {
    return (
        <Group mt="xl" gap="xl" align="center" justify="left" { ...props }>
            <CreatedSmallBadge/>
            <FolderSmallBadge/>
        </Group>
    );
}

export default SmallBadgeContainer;

// TODO: SmallBadgeContainer.tsx / Created/FolderSmallBadge
//  In both components need to establish font colour as constant in theme.